export const configApp = (nameEnv, defaultValue) => {
    let result = defaultValue;
    if (process.env.REACT_APP_CONFIGS) {
        const configs = JSON.parse(process.env.REACT_APP_CONFIGS);
        if (nameEnv in configs) {
            result = configs[nameEnv];
        }
    }
    return result;
};

export default {
    configApp,
};



/** WEBPACK FOOTER **
 ** ./src/configs/parser.js
 **/